class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    try {
      this.addedItem = JSON.parse(sessionStorage.getItem('shc:last-added-item') || 'null');
    } catch {
      this.addedItem = null;
    }
    this.applyPresentation();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }
    this.applyPresentation();
    const scrollContainer = this.querySelector('.shc-drawer__body') || this.querySelector('.drawer__inner');
    scrollContainer.scrollTop = 0;
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.focusTimer && clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => {
      if (!this.classList.contains('active')) return;
      const container = this.querySelector('.drawer__inner');
      trapFocus(container, container);
    }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.focusTimer);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.addedItem = parsedState.key ? { key: parsedState.key, id: parsedState.id } : parsedState.items?.[0] || (parsedState.id ? parsedState : null);
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    if (!parsedState.sections?.['cart-drawer']) {
      window.location.assign(window.routes.cart_url);
      return;
    }
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  applyPresentation() {
    const rows = Array.from(this.querySelectorAll('[data-shc-line-key]'));
    const chosen = (this.addedItem && (rows.find((row) => row.dataset.shcLineKey === this.addedItem.key) || rows.find((row) => row.dataset.shcVariantId === String(this.addedItem.id)))) || rows[0];
    this.addedItem = chosen ? { key: chosen.dataset.shcLineKey, id: chosen.dataset.shcVariantId } : null;
    try {
      if (this.addedItem) sessionStorage.setItem('shc:last-added-item', JSON.stringify(this.addedItem));
      else sessionStorage.removeItem('shc:last-added-item');
    } catch {}
    const heading = this.querySelector('[data-shc-cart-heading]');
    if (heading) heading.textContent = heading.dataset.cartTitle;
    const recommendations = this.querySelector('shc-cart-recommendations');
    if (recommendations && chosen) recommendations.dataset.productId = chosen.dataset.shcProductId;
    if (this.classList.contains('active')) recommendations?.load();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    queueMicrotask(() => this.closest('cart-drawer')?.applyPresentation());
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        const drawer = this.closest('cart-drawer');
        if (drawer) drawer.applyPresentation();
        return;
      }
      if (event.cartData?.sections?.['cart-drawer']) return;
      this.onCartUpdate();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

